<div class="action-overall-container">
    <div class="overall-header">
        <div class="overall-heading ltms-widget-title">
            {{ leftUpperBoxHeading }}
        </div>
        <div class="overall-discription ltms-description">
            {{ leftUpperBoxDiscription }}
        </div>
    </div>
    <div class="overall-pannel" *ngIf="totalResponses !== null">
        <div class="overall-left-panal">
            <div class="overall-score-panel">
                <div class="panel-title">Total Responses</div>
                <div class="panel-count"> {{totalResponses}} </div>
            </div>
        </div>
        <div class="overall-right-panal">
            <div class="overall-score-panel">
                <div class="panel-title">Actionable Issues</div>
                <div class="panel-count"> {{totalActionableResponses}} </div>
            </div>
        </div>
    </div>
    <div class="data-details-loader" *ngIf="totalResponses == null">
        <app-ltms-loader></app-ltms-loader>
    </div>
</div>